import styled from 'styled-components';

const TooltipWrapper = styled.ul`
  position: relative;
  background: white;
  width: 197px;
  min-width: 197px;
  min-height: 26px;
  border: 1px solid #00819b;
  border-radius: 6px;
  ::after {
    content: '';
    position: absolute;
    right: 10px;
    top: -7.9px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 9.1px solid white;
    clear: both;
  }
  ::before {
    content: '';
    position: absolute;
    right: 10px;
    top: -9.5px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 9.1px solid #00819b;
    clear: both;
  }
  padding: 2px 0px 4px 0px;
  z-index: 10;
`;

export default TooltipWrapper;



// WEBPACK FOOTER //
// ./components/atoms/TooltipWrapper.js